import React,{useEffect,useState} from 'react'
import { LayoutStyle } from './Layout.styled'
import TopBar from '../TopBar/TopBar'
import NavBar from '../NavBar/NavBar'
import useInternetConnectivity from '../../hooks/useInternetConnectivity'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import Home from '../../pages/Home'
import Account from '../../pages/Account/Account'
import BaseStation from '../../pages/BaseStation/BaseStation'
import Beacon from '../../pages/Beacon/Beacon'
import Footer from '../footer/Footer'
import { useDB } from '../../context/DynamoDBContext'
import { useNavigate } from 'react-router-dom';
import { persistor } from '../../redux/reduxStore';
import LogoutModal from '../Modals/LogoutModal';
import { RefreshTokenAPI } from '../../api/NavBarApi'
import { setToken } from '../../redux/roles/userApiSlice'
import { useQuery } from '@tanstack/react-query';

const Layout = () => {
  const isOnline=useInternetConnectivity();
  const navigateRed=useSelector(state=>state.navigateRed)
  const userRole=useSelector(state=>state.userRoleRed)
  const userKey=useSelector(state=>state.userKeyRed)
  const dispatch=useDispatch()
  
  const {setDBClient}=useDB()
  const navigate=useNavigate();
  const [showModal, setShowModal] = useState(false)

  

 const {
    status : refreshTokenStatus,
    data:refreshTokenData,
  }=useQuery({
    queryKey:["refreshToken"],
    queryFn:()=>RefreshTokenAPI(userKey.access_token),
    staleTime:8*60*1000,
    cacheTime:8*60*1000,
    refetchInterval:8*60*1000,
    onSuccess:(item)=>{
      if(item!==""){
        dispatch(setToken(item)) 
      }else{
        setShowModal(true)
      }
    }
  })

  useEffect(() => {
    if(!isOnline){
      toast.error("Internet Not Connected",{
      bodyClassName:"notification-div-error",
      progressClassName:"progress-bar-error",
      icon:{}
    })
    }
  }, [isOnline])

    const handleLogout=async ()=> {
    // TODO: Handle logout logic
    setDBClient(null)
    await persistor.purge().then(res=>{
    }).catch(err=>console.error(err))
    navigate("/")
  }
  
  
  
  return (
    <LayoutStyle>
      <LogoutModal 
        title='Logout'
        visible={showModal}
        setVisible={()=>setShowModal(false)}
        message={"Your Session has been Expired."}
        onAccept={()=>{
          setShowModal(false)
          handleLogout()
        }}
      />
      
        <div className='main-box'>

          <div id="nav">
            <TopBar authorized={true}  />
          </div>
          
          <div className='children-box' id="page">
            <NavBar />            
            {navigateRed.navigateTo === 0 && <Home />}            
            {navigateRed.navigateTo === 1 && <Account title={navigateRed.title} id={navigateRed.id}/>}            
            {navigateRed.navigateTo === 2 && <BaseStation title={navigateRed.title} id={navigateRed.id} email={navigateRed.email} />}            
            {navigateRed.navigateTo === 3 && <Beacon title={navigateRed.title} id={navigateRed.id} email={navigateRed.email}/>}            
          </div>
          <Footer style={userRole.role?"footer2":"footer"} />
        

        </div>
        
    </LayoutStyle>
  )
}

export default Layout



      